import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Form } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";

@inject("store")
@observer
class AddExchangeAccount extends Component {
  state = {
    name: this.props.exchangeAccount.name || "",
    apiKey: "",
    secret: "",
  };

  submitExchangeAccount = async () => {
    const { exchangeAccount } = this.props;
    const { name, apiKey, secret } = this.state;

    let axiosRequest = axios.create({
      baseURL: "api",
      timeout: 30 * 1000,
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      await axiosRequest.post(`exchangeAccount/${exchangeAccount.id ? "edit" : "add"}ExchangeAccount`, {
        id: exchangeAccount.id,
        exchangeType: exchangeAccount.exchange,
        name,
        apiKey,
        secret,
      });

      this.props.onSuccess();
    } catch (e) {
      alert(e);
    }
  };

  render() {
    const { exchangeAccount } = this.props;

    return (
      <Form
        style={{
          maxWidth: "1200px",
          margin: "10px",
        }}
        onSubmit={this.submitExchangeAccount}
      >
        <h3>
          {exchangeAccount.id ? "Edit" : "New"} {exchangeAccount.exchange} Exchange Account
        </h3>
        <Form.Field>
          <label>Name</label>
          <input
            placeholder="Name"
            required
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
          />
        </Form.Field>
        <Form.Field>
          <label>API Key</label>
          <input
            placeholder={"API Key " + (exchangeAccount.id ? "(leave empty if not changing credentials)" : "")}
            required={!exchangeAccount.id}
            autoComplete="no"
            onChange={e => this.setState({ apiKey: e.target.value })}
          />
        </Form.Field>
        <Form.Field>
          <label>Secret</label>
          <input
            placeholder={"Secret " + (!this.state.apiKey ? "(enter API Key first )" : "")}
            required={!exchangeAccount.id || this.state.apiKey}
            readOnly={!this.state.apiKey}
            autoComplete="no"
            onChange={e => this.setState({ secret: e.target.value })}
          />
        </Form.Field>
        <Button primary icon="checkmark" content="Submit" type="submit" />
        <Button icon="close" content="Close" onClick={this.props.onClose} />
      </Form>
    );
  }
}

export default AddExchangeAccount;



// WEBPACK FOOTER //
// ./src/exchangeAccounts/AddExchangeAccount.js